class Inview {
  constructor(node, options = {}) {
    this.props = {
      name: 'inview',
      rootMargin: '0px 0px 0px 0px',
      threshold: 1.0,
      timeout: 0,
      props: [],
      ...options,
    };
    this.node = node;
    this.node.decorator = this;
    this.timeout = null;

    this.node.classList.add(`${this.props.name}-enter`);
    this.registerObserver();
  }

  registerObserver = () => {
    const { rootMargin, threshold } = this.props;
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin,
      threshold,
    });
    this.observer.observe(this.node);
  };

  removeClasses = e => {
    const { props } = this.props;
    if (e) {
      if (props.length > 0) {
        if (props.indexOf(e.propertyName) !== -1) {
          clearTimeout(this.timeout);
          this.node.classList.remove(`${this.props.name}-enter`);
          this.node.classList.remove(`${this.props.name}-enter-active`);
        }
      } else {
        clearTimeout(this.timeout);
        this.node.classList.remove(`${this.props.name}-enter`);
        this.node.classList.remove(`${this.props.name}-enter-active`);
      }
    } else {
      clearTimeout(this.timeout);
      this.node.classList.remove(`${this.props.name}-enter`);
      this.node.classList.remove(`${this.props.name}-enter-active`);
    }
  };

  onIntersection = entries => {
    entries.forEach(({ intersectionRatio }) => {
      if (intersectionRatio > 0) {
        this.timeout = setTimeout(this.removeClasses, this.props.timeout);
        this.node.addEventListener('transitionend', this.removeClasses);
        this.node.classList.add(`${this.props.name}-enter-active`);
      }
    });
  };
}

export default (node, props) => new Inview(node, props);
